import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import {UIState} from "data/UIState";
import * as ReactDOM from "react-dom";
import * as FocusTrap from "focus-trap-react";
import {handleSpacePressed} from "utils";

interface Props {
  children: any;
  title: string;
}

/**
 * Full browser chart display
 */
@observer
export class ChartModal extends React.Component<Props> {
  @observable currentGraph: number = 0;
  @observable oldTitle:string = '';
  titleRef;

  constructor(props:Props) {
    super(props);
    UIState.POJSshowFullBrowserMask();
    // this.titleRef = React.createRef();
  }

  componentDidMount() {
    // if(this.titleRef && this.titleRef.current) {
    //   this.titleRef.current.focus();
    // }
    this.oldTitle = document.title;
    document.title = this.props.title;
  }

  handleCloseChartModal = () => {
    UIState.POJShideFullBrowserMask();
    document.title = this.oldTitle;
    setTimeout(() => {
      ReactDOM.render(<span></span>, document.getElementById('fullbrowserbody'))
    }, 500)
  }

  showPreviousGraph = () => {
    this.currentGraph = this.currentGraph - 1;
  }

  showNextGraph = () => {
    this.currentGraph = this.currentGraph + 1;
  }

  render() {
    return (
      <FocusTrap focusTrapOptions={
        {
          allowOutsideClick: false,
          clickOutsideDeactivates: true,
          // onPostActivate:()=>{ console.log('Focus Trap onPostActivate') },
          // onActivate:()=>{ console.log('Focus Trap onActivate') },
          onDeactivate:()=>{ this.handleCloseChartModal(); },
          // onPostDeactivate:()=>{ console.log('Focus Trap onPostDeactivate') },
          //initialFocus: '#graph-title',
          //delayInitialFocus: true,
        }
      }

      >
        <div className="chart" aria-modal="true" role="dialog">
          <div tabIndex={0} role={"button"} className="button close no-print three-band-focus"
               onClick={this.handleCloseChartModal}
               onKeyDown={(e)=>{ handleSpacePressed(e, this.handleCloseChartModal);}}
               style={{zIndex:1000}}
          >EXIT</div>

          <h1 id="graph-title" className={'level1 title'} tabIndex={-1} aria-label={this.props.title}><span><i className="icon-graph" aria-hidden></i> {this.props.title}</span></h1>

          {this.props.children[this.currentGraph]}


          {this.currentGraph > 0 &&
            <a  tabIndex={0} role={"button"} className="previous no-print three-band-focus"
                onClick={this.showPreviousGraph}
                onKeyDown={(e)=>{ handleSpacePressed(e, this.showPreviousGraph);}}
            ><i className="fa fa-angle-left"></i></a>}
          {this.currentGraph < this.props.children.length - 1 &&
            <a  tabIndex={0} role={"button"} className="next no-print three-band-focus"
                onClick={this.showNextGraph}
                onKeyDown={(e)=>{ handleSpacePressed(e, this.showNextGraph);}}
            ><i className="fa fa-angle-right"></i></a>}
        </div>
      </FocusTrap>

    );
  }
}
